module.exports = __webpack_public_path__ + "static/media/logoTwoMinBlack.61d61e8d.svg";